define("shared/components/shared/carousel/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _utils, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class={{concat-classes @class "cPM--videoThumbnailPreview__mediaWrapper carousel slide"}}
    {{did-insert this.addListener}}
    {{will-destroy this.removeListener}}
    ...attributes
  >
    {{yield
      (hash
        indicators=(component
          "shared/carousel/indicators"
          carouselMediaItems=@carouselMediaItems
          index=this.index
          updateIndex=this.clickedUpdate
        )
        inner=(component "shared/carousel/inner" carouselMediaItems=@carouselMediaItems index=this.index)
        controls=(component
          "shared/carousel/controls"
          carouselMediaItems=@carouselMediaItems
          index=this.index
          updateIndex=this.limitedUpdate
        )
        currentIndex=this.index
      )
    }}
  </div>
  */
  {
    "id": "pYUVHcbX",
    "block": "[[[11,0],[16,0,[28,[37,0],[[30,1],\"cPM--videoThumbnailPreview__mediaWrapper carousel slide\"],null]],[17,2],[4,[38,1],[[30,0,[\"addListener\"]]],null],[4,[38,2],[[30,0,[\"removeListener\"]]],null],[12],[1,\"\\n  \"],[18,4,[[28,[37,4],null,[[\"indicators\",\"inner\",\"controls\",\"currentIndex\"],[[50,\"shared/carousel/indicators\",0,null,[[\"carouselMediaItems\",\"index\",\"updateIndex\"],[[30,3],[30,0,[\"index\"]],[30,0,[\"clickedUpdate\"]]]]],[50,\"shared/carousel/inner\",0,null,[[\"carouselMediaItems\",\"index\"],[[30,3],[30,0,[\"index\"]]]]],[50,\"shared/carousel/controls\",0,null,[[\"carouselMediaItems\",\"index\",\"updateIndex\"],[[30,3],[30,0,[\"index\"]],[30,0,[\"limitedUpdate\"]]]]],[30,0,[\"index\"]]]]]]],[1,\"\\n\"],[13]],[\"@class\",\"&attrs\",\"@carouselMediaItems\",\"&default\"],false,[\"concat-classes\",\"did-insert\",\"will-destroy\",\"yield\",\"hash\",\"component\"]]",
    "moduleName": "shared/components/shared/carousel/index.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::Carousel
   * @extends Component
   *
   * This component renders a carousel of media items with arrow controls and index indicator.
   * It can manage its own internal carousel state, allowing users to navigate from 0
   * index to the end using navigation arrows or index indicator.
   *
   * Alternatively, if you pass in an `index` and a callback function `updateIndex`,
   * you can yield control to a parent component. The `inner` component can be invoked
   * as a block for maximum flexibility.
   *
   **/
  let SharedCarouselComponent = _exports.default = (_class = class SharedCarouselComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "internalIndex", _descriptor, this);
      _defineProperty(this, "_debouncedIndexUpdate", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (index) {
          this.index = index;
        }
      }), null, "_debouncedIndexUpdate", "drop"));
      const hasAtLeastOneIndex = (0, _utils.isPresent)(this.args.index) || (0, _utils.isPresent)(this.args.updateIndex);
      const missingAtLeastOneIndex = (0, _utils.isEmpty)(this.args.index) || (0, _utils.isEmpty)(this.args.updateIndex);
      const isMissingOneArg = missingAtLeastOneIndex && hasAtLeastOneIndex;
      if (isMissingOneArg) {
        throw new Error('Both index and updateIndex must be passed in if either is passed in.');
      }
    }
    get index() {
      return this.args.index ?? this.internalIndex;
    }
    set index(index) {
      this.args.updateIndex?.(index) || (this.internalIndex = index);
    }
    addListener(element) {
      this.carouselListener = element.addEventListener('slide.bs.carousel', event => this._debouncedIndexUpdate.perform(event.relatedTarget.dataset.index));
    }
    removeListener(element) {
      element.removeEventListener('slide.bs.carousel', this.carouselListener);
    }
    limitedUpdate(index) {
      const newIndex = this.index + index;
      this._debouncedIndexUpdate.perform(newIndex);
    }
    clickedUpdate(index) {
      this._debouncedIndexUpdate.perform(index);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "internalIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addListener", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeListener", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "limitedUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "limitedUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickedUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clickedUpdate"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedCarouselComponent);
});